export const PRODUCT = {
  HOME: 'product',
  HOME_JP: 'product_jp',
  MASTER_PP: 'master-pp',
  IPHONE_17: 'iphone-17',
  VISIBLE_BY_VERIZON_DRAWER: 'visible_by_verizon_drawer',
  PROCESSOR_DRAWER: 'processor_drawer',
  EXTERNAL_PAGE_VERIFIED_REFURBISHED: 'verified-refurbished',
  OBSOLETE_DRAWER: 'obsolete_drawer',
}
